import { Order, OrderState, OrderType } from '@protos/v2/order';
import { toastifyService } from '@services/ToastifyService';
import { ChannelType, StreamEvent, StreamV2, Subscription } from '../StreamV2';

export type OrderNotificationCallback = (order: Order) => void;

export const streamV2OrderNotificationService = (stream: StreamV2) => {
  const tradingSubscribers: Map<string, Set<OrderNotificationCallback>> = new Map();
  const DTsubscribers: Set<OrderNotificationCallback> = new Set();

  stream.onEvent(ChannelType.Orders, (event: StreamEvent) => {
    const order = event.asOrder();
    if (!order) return;

    if (order.order_state !== OrderState.FILLED && order.order_state !== OrderState.PARTIALLY_FILLED) return;

    if (order.order_type === OrderType.LIMIT_MAKER && order.exchange === 'onyx') {
      toastifyService.showQuoteBookTradeConfirmation(order);
    }

    const accountCallbacks = tradingSubscribers.get(order.account_id);
    if (accountCallbacks) {
      accountCallbacks.forEach(callback => callback(order));
    }
    // Filter ABN accounts (trad) - DT users only see external account orders
    if (!order.account_id.startsWith('trad')) {
      DTsubscribers.forEach(callback => callback(order));
    }
  });

  stream.onConnect(() => {
    if (tradingSubscribers.size > 0 || DTsubscribers.size > 0) {
      stream.subscribe(Subscription.order());
    }
  }, ChannelType.Orders);

  const subscribe = (accountId: string, callback: OrderNotificationCallback) => {
    if (accountId === 'DT') {
      DTsubscribers.add(callback);
    } else {
      if (!tradingSubscribers.has(accountId)) {
        tradingSubscribers.set(accountId, new Set());
      }
      tradingSubscribers.get(accountId)?.add(callback);
    }
    stream.subscribe(Subscription.order());
  };

  const unsubscribe = (accountId: string, callback: OrderNotificationCallback) => {
    if (accountId === 'DT') {
      DTsubscribers.delete(callback);
    } else {
      const callbacks = tradingSubscribers.get(accountId);
      if (callbacks) {
        callbacks.delete(callback);
        if (callbacks.size === 0) {
          tradingSubscribers.delete(accountId);
        }
      }
    }
  };

  return { subscribe, unsubscribe };
};
